import axios from "axios";
import { TokenManager } from "../utils/tokenManager";

const api = axios.create({
  baseURL: "https://ctmapi.zerlak.com/api/v1/",
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Attach JWT token automatically
api.interceptors.request.use(
  (config) => {
    const token = TokenManager.getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.error("No authentication token found in request interceptor");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("401 Unauthorized Error:", {
        url: error.config?.url,
        method: error.config?.method,
        headers: error.config?.headers,
        responseData: error.response?.data
      });
    }
    return Promise.reject(error);
  }
);

export default api;
